import { FORM_FIELDS } from '../consts';

export const accountantForm = () => [
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        maxLen: 20,
        name: 'First Name',
        requiredMessage: 'First name is required',
        validateScheme: /[^\s]{2,}/,
        validateErrorMessage: 'Minimum 2 characters',
        inputId: FORM_FIELDS.FIRST_NAME,
        shouldValidateOnClick: true,
      },
      {
        inputType: 'text',
        maxLen: 20,
        name: 'Last Name',
        requiredMessage: 'Last name is required',
        validateScheme: /[^\s]{2,}/,
        validateErrorMessage: 'Minimum 2 characters',
        inputId: FORM_FIELDS.LAST_NAME,
        shouldValidateOnClick: true,
      },
    ],
  },
  {
    type: 'multiple',
    children: [
      {
        inputType: 'text',
        name: 'Phone Number',
        maxLen: 17,
        requiredMessage: 'Phone number is required',
        validateScheme: /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/,
        validateErrorMessage: 'Enter a valid phone number',
        inputId: FORM_FIELDS.PHONE,
        maskType: 'PHONE',
        shouldValidateOnClick: true,
      },
      {
        inputType: 'text',
        name: 'Register Date',
        requiredMessage: '',
        validateScheme: '',
        validateErrorMessage: '',
        inputId: FORM_FIELDS.TIME_STAMP,
        shouldValidateOnClick: true,
        disabled: true,
        disableClearButton: true,
      },
    ],
  },
];
